module.exports = __webpack_public_path__ + "static/media/interview01.559df6df.jpg";